import React from 'react';
import { motion } from 'framer-motion';
import BrazilAccentSVG from './BrazilAccentSVG';

export default function BrazilHero({ locale }) {
  const t = locale === 'pt-BR'
    ? {
        title: 'Tokenização confiável. Impacto mensurável. Liquidez instantânea.',
        tagline: 'Finanças regenerativas para um Brasil mais sustentável.',
        cta: 'Começar agora',
      }
    : {
        title: 'Trusted tokenization. Measurable impact. Instant liquidity.',
        tagline: 'Regenerative finance for a more sustainable Brazil.',
        cta: 'Get Started',
      };

  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      style={{
        position: 'relative',
        padding: '140px 32px 120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        overflow: 'hidden',
        minHeight: 480,
      }}
    >
      {/* Animated Brazil SVG accent */}
      <motion.div
        style={{ position: 'absolute', left: '50%', top: 38, transform: 'translateX(-50%)', zIndex: 0 }}
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: [0.92, 1.04, 1] }}
        transition={{ duration: 1.2, type: 'spring', stiffness: 120 }}
        aria-hidden
      >
        <BrazilAccentSVG style={{ width: 220, height: 60 }} />
      </motion.div>
      {/* Subtle animated background */}
      <motion.div
        aria-hidden
        style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 50% 30%, rgba(20,184,141,0.18), transparent 70%)', pointerEvents: 'none', zIndex: 0 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.4 }}
      />
      {/* Cinematic, trust-forward About hero */}
      <motion.h1
        style={{
          fontSize: 'clamp(2.6rem,6vw,4.2rem)',
          lineHeight: 1.08,
          fontWeight: 700,
          background: 'linear-gradient(90deg,#14B88D,#F5C84C,#fff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          margin: 0,
          letterSpacing: '-1px',
          zIndex: 1,
          textShadow: '0 2px 16px #0C0D0E88,0 1.5px 0 #14B88D',
        }}
        initial={{ scale: 0.96 }}
        animate={{ scale: [0.96, 1.03, 1] }}
        transition={{ duration: 1.1, type: 'spring', stiffness: 120 }}
      >
        {t.title}
      </motion.h1>
      <motion.p
        style={{
          maxWidth: 720,
          fontSize: 'clamp(.98rem,1.8vw,1.25rem)',
          opacity: 0.88,
          margin: '32px auto 42px',
          color: '#BFEFDD',
          fontWeight: 500,
          zIndex: 1,
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.7 }}
      >
        {t.tagline}
      </motion.p>
      <motion.div
        style={{ display: 'flex', gap: 18, zIndex: 1 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.55 }}
      >
        <motion.button
          whileHover={{ scale: 1.06, boxShadow: '0 0 0 6px rgba(20,184,141,0.35)' }}
          whileTap={{ scale: 0.94 }}
          style={{
            background: 'linear-gradient(90deg,#14B88D,#F5C84C)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '1.05rem',
            padding: '14px 34px',
            border: 'none',
            borderRadius: 14,
            cursor: 'pointer',
            letterSpacing: '.5px',
            boxShadow: '0 8px 32px -8px #14B88D33, 0 1.5px 0 #F5C84C44',
          }}
        >
          {t.cta}
        </motion.button>
      </motion.div>
    </motion.section>
  );
}